import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse } from "schema"

type Response = DataResponse<string[]>

export const shopifyOrderTagsQuery = () =>
  queryOptions({
    queryKey: ["shopifyOrderTags"],
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/shopify/order-tags`)
      return response.data.data
    },
    staleTime: 5 * 60 * 1000,
  })
